import { render, staticRenderFns } from "./nieuwsbrief.vue?vue&type=template&id=152a9c7c"
import script from "./nieuwsbrief.vue?vue&type=script&lang=js"
export * from "./nieuwsbrief.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports